import { render, staticRenderFns } from "./BoxwrapItems.vue?vue&type=template&id=df65ac96"
import script from "./BoxwrapItems.vue?vue&type=script&lang=js"
export * from "./BoxwrapItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports